export default class AssetsHelper {
	static getFileIcon(extension) {
		if (!extension && typeof extension != "string") return null;

		extension = extension.toLowerCase();

		let fileIcon = require('../assets/images/file_icons/file.svg');

		if (extension == "pdf") {
			fileIcon = require('../assets/images/file_icons/pdf.svg');
		} else if (extension == "doc" || extension == "docx" || extension == "odt") {
			fileIcon = require('../assets/images/file_icons/doc.svg');
		} else if (extension == "xlsx" || extension == "xls" || extension == "ods") {
			fileIcon = require('../assets/images/file_icons/xls.svg');
		} else if (extension == "pptx" || extension == "ppt" || extension == "odp") {
			fileIcon = require('../assets/images/file_icons/ppt.svg');
		} else if (extension == "jpg" || extension == "jpeg") {
			fileIcon = require('../assets/images/file_icons/jpg.svg');
		} else if (extension == "png") {
			fileIcon = require('../assets/images/file_icons/png.svg');
		} else if (extension == "zip") {
			fileIcon = require('../assets/images/file_icons/zip.svg');
		} else if (extension == "txt") {
			fileIcon = require('../assets/images/file_icons/txt.svg');
		} else if (extension == "xml") {
			fileIcon = require('../assets/images/file_icons/xml.svg');
		} else if (extension == "mp3") {
			fileIcon = require('../assets/images/file_icons/mp3.svg');
		} else if (extension == "raw") {
			fileIcon = require('../assets/images/file_icons/raw.svg');
		} else if (extension == "svg") {
			fileIcon = require('../assets/images/file_icons/svg.svg');
		} else if (extension == "deleted") {
			fileIcon = require('../assets/images/file_icons/file_deleted.svg');
		}

		return fileIcon;
	}
}
